import { useLayoutStore } from '@src/stores-v2/StoreContext';
import throttle from 'lodash/throttle';
import { useCallback, useRef, useState } from 'react';

import { getDocumentHeight } from '../utility/general';

export function useTimelineLayoutResize() {
  const layoutStore = useLayoutStore();
  const { timelineHeight } = layoutStore;

  const [isDragging, setIsDragging] = useState(false);
  const initialMouseY = useRef<number | null>(null);
  const initialHeight = useRef<number | null>(null);

  const handleMouseMove = useCallback((e: MouseEvent) => {
    if (initialMouseY.current !== null && initialHeight.current !== null) {
      let documentHeight = getDocumentHeight();

      const currentHeight = initialHeight.current * 0.01 * documentHeight;
      const deltaY = initialMouseY.current - e.clientY;

      const updatedHeight = currentHeight + deltaY;
      const updatedHeightPercent = (updatedHeight / documentHeight) * 100;

      const newHeightPercentage = Math.min(
        Math.max(updatedHeightPercent, 10),
        100,
      );

      layoutStore.setTimelineHeight(newHeightPercentage);
    }
  }, []);

  const throttledHandleMouseMove = useRef(
    throttle((e: MouseEvent) => {
      handleMouseMove(e);
    }, 100),
  ).current;

  const handleMouseDown = useCallback(
    (e: MouseEvent) => {
      initialMouseY.current = e.clientY;
      initialHeight.current = parseFloat(timelineHeight);
      setIsDragging(true);
    },
    [timelineHeight],
  );

  const handleMouseUp = useCallback(() => {
    initialMouseY.current = null;
    initialHeight.current = null;
    setIsDragging(false);
  }, []);

  return {
    isDragging,
    handleMouseMove,
    throttledHandleMouseMove,
    handleMouseDown,
    handleMouseUp,
  };
}
